
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IEntity } from '@/entity/shared/EntityStoreTypes';
import { vxm } from '@/store';

@Component
export default class SelectEntity extends Vue {
    private entity: IEntity | null = null;
    private entityError: string = '';

    public get entitiesOptions () { return vxm.entity.entities;
    }

    public get isLoading(): boolean {
        return !this.entitiesOptions || this.entitiesOptions.length === 0;
    }

    public selectEntity(): void {
        this.entityError = '';
        if (!this.entity) {
            this.entityError = 'Veuillez sélectionner une entité.';
            return;
        }
        this.$emit('confirm', this.entity); // Emit the selected entity to parent
    }
}
